module.exports = __webpack_public_path__ + "static/img/fullBody5.5d84ad9e.png";